import { PdfFieldWidget } from "./pdfFields";
import { QrCodeSpec } from "../models/TemplateMeta";

export type ResolvedQrPlacement = {
    pageIndex: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

const defaultQrSize = 120;

export function resolveQrPlacement(
    qr: QrCodeSpec,
    pageHeightPt: number,
    pageWidthPt: number = 0,
): ResolvedQrPlacement | null {
    const size = qr.size ?? defaultQrSize;
    const origin = qr.position.origin ?? "top-left";
    const fromRight = origin === "top-right" || origin === "bottom-right";
    const fromTop = origin === "top-left" || origin === "top-right";

    const x = fromRight ? pageWidthPt - qr.position.x - size : qr.position.x;
    const y = fromTop ? pageHeightPt - qr.position.y - size : qr.position.y;

    return {
        pageIndex: Math.max(0, Math.floor(qr.position.page) - 1),
        x,
        y,
        width: size,
        height: size,
    };
}
